/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('loracube', [
  'getActivate',
]);

function getActivate() {
  return createAPIAction(
    types.getActivate,
    {
      endpoint: '/loracube/activate',
      method: 'GET',
    })();
}

export default {
  getActivate,
};




// WEBPACK FOOTER //
// ./src/redux/actions/loracube.js